import { render, staticRenderFns } from "./folders-ports-countries-options-beth-list-detail.vue?vue&type=template&id=26747368&scoped=true"
import script from "./folders-ports-countries-options-beth-list-detail.vue?vue&type=script&lang=js"
export * from "./folders-ports-countries-options-beth-list-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26747368",
  null
  
)

export default component.exports